export const version = "wallet/5.5.0";
